<div class="lv-modal-mask" [@mask]
  *ngIf="isOpened"
  [ngClass]="maskClass">
</div>
<div class="lv-modal" [@modal]
  *ngIf="isOpened"
  [ngClass]="modalClass">
  <div class="lv-modal-table">
    <div class="lv-modal-table-cell">
      <div class="lv-modal-table-cell-content">
        <div class="lv-modal-container">
            <div class="lv-modal-title">
              Multiple Instances
            </div>
            <div class="lv-modal-content">
              <div>You already have an instance of this application open</div>              
            </div>
            <!-- <div class="lv-modal-footer">
              <button
                kendoButton
                [primary]="true"
                (click)="onReloadApplication()">
                Reload Application
              </button>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</div>